import { AdminSaveForm, parseBase } from "./AdminSaveForm";
import { adminFieldClass, adminLabelClass } from "./adminFields";
import { useSiteContent } from "../lib/content";

export function AdminContactos() {
  const { content } = useSiteContent();
  const contact = content.contact;

  return (
    <AdminSaveForm
      title="Contactos"
      hint="Telefone, email, WhatsApp e zona de atuação. Também aparecem no rodapé."
      build={(form) => ({
        ...parseBase(form),
        contact: {
          heading: String(form.get("heading") ?? ""),
          subtitle: String(form.get("subtitle") ?? ""),
          name: String(form.get("name") ?? ""),
          phone: String(form.get("phone") ?? ""),
          email: String(form.get("email") ?? ""),
          zone: String(form.get("zone") ?? ""),
          coverage: String(form.get("coverage") ?? ""),
          whatsapp: String(form.get("whatsapp") ?? ""),
          whatsappMessage: String(form.get("whatsappMessage") ?? ""),
        },
      })}
    >
      <label className={adminLabelClass}>
        Título da secção
        <input name="heading" className={adminFieldClass} defaultValue={contact.heading} />
      </label>
      <label className={adminLabelClass}>
        Subtítulo
        <input name="subtitle" className={adminFieldClass} defaultValue={contact.subtitle} />
      </label>
      <label className={adminLabelClass}>
        Nome no site
        <input name="name" className={adminFieldClass} defaultValue={contact.name} />
      </label>
      <div className="grid gap-4 sm:grid-cols-2">
        <label className={adminLabelClass}>
          Telefone
          <input name="phone" className={adminFieldClass} defaultValue={contact.phone} />
        </label>
        <label className={adminLabelClass}>
          Email
          <input name="email" type="email" className={adminFieldClass} defaultValue={contact.email} />
        </label>
      </div>
      <label className={adminLabelClass}>
        Zona de atuação
        <input name="zone" className={adminFieldClass} defaultValue={contact.zone} />
      </label>
      <label className={adminLabelClass}>
        Texto da área de cobertura
        <textarea name="coverage" rows={3} className={adminFieldClass} defaultValue={contact.coverage} />
      </label>
      <div className="grid gap-4 sm:grid-cols-2">
        <label className={adminLabelClass}>
          WhatsApp (só dígitos, com indicativo)
          <input name="whatsapp" className={adminFieldClass} defaultValue={contact.whatsapp} />
        </label>
        <label className={adminLabelClass}>
          Mensagem inicial do WhatsApp
          <input name="whatsappMessage" className={adminFieldClass} defaultValue={contact.whatsappMessage} />
        </label>
      </div>
    </AdminSaveForm>
  );
}
